"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactPlayer = _interopRequireDefault(require("react-player"));

var _utils = _interopRequireDefault(require("../../../utils"));

var _windowWrapper = _interopRequireDefault(require("../../../utils/window/windowWrapper"));

var _player = _interopRequireDefault(require("@vimeo/player"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var VideoItem =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(VideoItem, _React$Component);

  function VideoItem(props) {
    var _this;

    _this = _React$Component.call(this, props) || this; //Vimeo player must be loaded by us, problem with requireJS

    if (!(_windowWrapper["default"] && _windowWrapper["default"].Vimeo) && props.videoUrl && props.videoUrl.includes('vimeo.com')) {
      _windowWrapper["default"].Vimeo = {
        Player: _player["default"]
      };
    }

    _this.pause = _this.pause.bind(_assertThisInitialized(_this));
    _this.play = _this.play.bind(_assertThisInitialized(_this));
    _this.state = {
      playedOnce: false,
      playing: false
    };
    return _this;
  }

  var _proto = VideoItem.prototype;

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.playing) {
      this.setState({
        playedOnce: true
      });
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.currentIdx !== this.props.currentIdx) {
      this.fixIFrameTabIndexIfNeeded();
    }
  };

  _proto.play = function play() {
    this.props.playVideo(this.props.idx);
  };

  _proto.pause = function pause() {
    this.props.pauseVideo();
  } //-----------------------------------------| UTILS |--------------------------------------------//
  ;

  _proto.createPlayerElement = function createPlayerElement() {
    var _this2 = this,
        _React$createElement;

    //video dimensions are for videos in grid fill - placing the video with negative margins to crop into a square
    var isWiderThenContainer = this.props.style.ratio >= this.props.cubeRatio;
    var videoDimensionsCss = {
      width: isWiderThenContainer ? '100%' : 'auto',
      height: isWiderThenContainer ? 'auto' : '100%',
      opacity: this.props.loadingStatus ? '1' : '0'
    };

    if (this.props.styleParams.cubeImages && this.props.styleParams.cubeType === 'fill') {
      //grid crop mode
      var _ref = [videoDimensionsCss.height, videoDimensionsCss.width];
      videoDimensionsCss.width = _ref[0];
      videoDimensionsCss.height = _ref[1];
      videoDimensionsCss.position = 'absolute';
      videoDimensionsCss.margin = 'auto';
      videoDimensionsCss.minHeight = '100%';
      videoDimensionsCss.minWidth = '100%';
      videoDimensionsCss.left = '-100%';
      videoDimensionsCss.right = '-100%';
      videoDimensionsCss.top = '-100%';
      videoDimensionsCss.bottom = '-100%';
    }

    var url = this.props.videoUrl ? this.props.videoUrl : this.props.resized_url.mp4;
    return _react["default"].createElement(_reactPlayer["default"], (_React$createElement = {
      className: 'gallery-item-visible video gallery-item',
      id: "video-" + this.props.id,
      width: "100%",
      height: "100%",
      onReady: this.props.actions.setItemLoaded,
      url: url,
      loop: !!this.props.styleParams.videoLoop,
      ref: function ref(player) {
        return _this2.video = player;
      },
      volume: this.props.styleParams.videoSound ? 0.8 : 0,
      playing: this.props.playing,
      onEnded: function onEnded() {
        _this2.setState({
          playing: false
        });

        _this2.props.onEnd();
      },
      onPause: function onPause() {
        _this2.setState({
          playing: false
        });
      },
      playbackRate: this.props.styleParams.videoSpeed || 1,
      onPlay: function onPlay() {
        _this2.setState({
          playing: true
        });
      }
    }, _React$createElement["onReady"] = function onReady() {
      _this2.fixIFrameTabIndexIfNeeded();
    }, _React$createElement.config = {
      file: {
        attributes: {
          muted: !this.props.styleParams.videoSound,
          preload: 'metadata',
          poster: this.props.resized_url.img,
          style: videoDimensionsCss
        }
      }
    }, _React$createElement.key = 'video-' + this.props.id, _React$createElement));
  };

  _proto.fixIFrameTabIndexIfNeeded = function fixIFrameTabIndexIfNeeded() {
    if (this.props.isExternalVideo) {
      var videoGalleryItem = _windowWrapper["default"].document && _windowWrapper["default"].document.getElementById("video-" + this.props.id);

      var videoIFrames = videoGalleryItem && videoGalleryItem.getElementsByTagName('iframe');
      var videoIFrame = videoIFrames && videoIFrames[0];

      if (videoIFrame) {
        if (this.props.currentIdx === this.props.idx) {
          videoIFrame.setAttribute('tabIndex', '0');
        } else {
          videoIFrame.setAttribute('tabIndex', '-1');
        }
      }
    }
  };

  _proto.createImageElement = function createImageElement() {
    var _this3 = this;

    return _react["default"].createElement("img", {
      ref: function ref(img) {
        // onLoad replacement for SSR
        if (!img) {
          return;
        }

        img.onload = _this3.props.actions.setItemLoaded; //initializing onLoad for further calls

        if (img.complete && !_this3.props.loadingStatus.loaded) {
          _this3.props.actions.setItemLoaded(); //first call, will not be called again because if it was called once loadingStatus.loaded will be true

        }
      },
      onError: this.props.actions.setItemError,
      key: 'image-' + this.props.id,
      className: 'gallery-item-hidden gallery-item-visible gallery-item ' + (this.props.loadingStatus.loaded ? ' gallery-item-loaded ' : '') + (this.props.loadingStatus.failed ? ' failed ' : ''),
      src: this.props.resized_url.img
    });
  };

  _proto.componentDidMount = function componentDidMount() {
    this.props.onMount(this);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.props.onUnmount();
  };

  _proto.canVideoPlayInGallery = function canVideoPlayInGallery(itemClick, videoPlay) {
    if (_utils["default"].isMobile() && itemClick !== 'expand' && itemClick !== 'fullscreen') return true;else if (!_utils["default"].isMobile() && itemClick !== 'expand' && itemClick !== 'fullscreen') return true;else if (!_utils["default"].isMobile() && videoPlay !== 'onClick') return true;else return false;
  };

  _proto.shouldRenderVideo = function shouldRenderVideo() {
    if (!this.state.playedOnce && (this.props.isExternalVideo || _utils["default"].isMobile())) {
      return false;
    }

    return true;
  } //-----------------------------------------| RENDER |--------------------------------------------//
  ;

  _proto.render = function render() {
    var baseClassName = 'gallery-item-content gallery-item-visible gallery-item-preloaded gallery-item-video gallery-item' + (_utils["default"].isiPhone() ? ' ios' : '') + (this.props.loadingStatus.loaded ? ' gallery-item-loaded ' : '');

    if (this.state.playing) {
      baseClassName += ' playing';
    }

    var videoControls = this.props.hidePlay ? false : [_react["default"].createElement("i", {
      key: "play-triangle",
      "data-hook": "play-triangle",
      className: 'gallery-item-video-play-triangle progallery-svg-font-icons-play-triangle '
    }), _react["default"].createElement("i", {
      key: "play-bg",
      "data-hook": "play-background",
      className: 'gallery-item-video-play-background progallery-svg-font-icons-play-background '
    })];

    var videoPreloader = _react["default"].createElement("div", {
      className: "pro-circle-preloader",
      key: 'video-preloader-' + this.props.idx
    });

    var _ref2 = this.props.imageDimensions || {},
        marginLeft = _ref2.marginLeft,
        marginTop = _ref2.marginTop,
        restOfDimensions = _objectWithoutPropertiesLoose(_ref2, ["marginLeft", "marginTop"]);

    var _this$props$stylePara = this.props.styleParams,
        videoPlay = _this$props$stylePara.videoPlay,
        itemClick = _this$props$stylePara.itemClick;
    var video = this.canVideoPlayInGallery(itemClick, videoPlay) && this.shouldRenderVideo() ? _react["default"].createElement("div", {
      className: baseClassName + ' animated fadeIn ',
      "data-hook": "video_container-video-player-element",
      key: 'video_container-' + this.props.id,
      style: _utils["default"].deviceHasMemoryIssues() ? {} : _objectSpread({
        backgroundImage: "url(" + this.props.resized_url.thumb + ")"
      }, restOfDimensions)
    }, this.createPlayerElement(), videoControls, videoPreloader) : _react["default"].createElement("div", {
      className: baseClassName,
      "data-hook": "video_container-image-element",
      key: 'video_container-' + this.props.id,
      style: _objectSpread({
        backgroundImage: "url(" + this.props.resized_url.thumb + ")"
      }, restOfDimensions)
    }, this.createImageElement(), videoControls, videoPreloader);
    var hover = this.props.hover;
    return _react["default"].createElement("div", {
      key: 'video-and-hover-container' + this.props.idx
    }, [video, hover]);
  };

  return VideoItem;
}(_react["default"].Component);

var _default = VideoItem;
exports["default"] = _default;